import { render, staticRenderFns } from "./EffectScene.vue?vue&type=template&id=623f9fbc&"
import script from "./EffectScene.vue?vue&type=script&lang=js&"
export * from "./EffectScene.vue?vue&type=script&lang=js&"
import style0 from "./EffectScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports